import { render, staticRenderFns } from "./LeaderboardGroup.vue?vue&type=template&id=621a0c7c"
import script from "./LeaderboardGroup.vue?vue&type=script&lang=js"
export * from "./LeaderboardGroup.vue?vue&type=script&lang=js"
import style0 from "./LeaderboardGroup.vue?vue&type=style&index=0&id=621a0c7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports